export default {
    dataRequestDonationLocation: '',
    dataDonationLocation: '',
    dataCreateBookingTab: '',
    dataBookingAppointment: '',
    showPage: '',
    actionVariableDonateBlood: '',
    entryPoint: '',

    stateDefault: {
        dataRequestDonationLocation: {
            pointOfEntry: 'standard',
            dateFrom: '',
            dateTo: '',
            type: '',
            eligibility: '||noeligibility|',
            zip: '',
            lat: '',
            lng: '',
            dist: '',
            donorId: '',
            siteType: '',
            newDonor: true,
            distanceOption: '',
            checkNewDonor: null,
            emailOldDonor: null,
        },
        dataDonationLocation: {
            responseData: '',
            profileId:'',
        },
        dataCreateBookingTab: {
            responseData: '',
        },
        dataBookingAppointment: {
            apptId: '',
            mobileCode: '',
            calendarApptId: '',
            blockedDate: null,
        },
        showPage: {
            triggerDonationLocation: false,
            triggerBookingAppointment: false,
        },
        actionVariableDonateBlood: {
            varReschedule: false,
            typeProcedure: '',
        },
        entryPoint: 'standard',
    }

}
